import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Paper, Typography } from '@mui/material';

export const NoAccess: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid>
      <Paper>
        <Box
          sx={{
            p: 5,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="h1">{t('pages.no-access.title')}</Typography>
          <Typography variant="body1">
            {t('pages.no-access.message')}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );
};
